import { GraduationCap } from "lucide-react";
import { Link } from "react-router";

const CoursesTab = ({ loading, sessions }) => (
  <div className="card bg-base-100 shadow-xl">
    <div className="card-body">
      <h2 className="card-title flex items-center gap-2">
        <GraduationCap className="h-5 w-5" />
        Enrolled Courses
      </h2>
      <p className="text-sm opacity-70 -mt-1 mb-4">Courses you're currently enrolled in</p>
      {loading ? (
        <div className="space-y-4">
          {[1, 2].map((i) => (
            <div key={i} className="skeleton h-20 w-full rounded-lg"></div>
          ))}
        </div>
      ) : (
        <div className="space-y-4">
          {Array.from(new Set(sessions.map((s) => s.topic_detail?.course_detail?.id)))
            .filter(Boolean)
            .map((courseId) => {
              const courseSession = sessions.find((s) => s.topic_detail?.course_detail?.id === courseId);
              const course = courseSession?.topic_detail?.course_detail;
              if (!course) return null;
              const courseTopics = new Set(
                sessions
                  .filter((s) => s.topic_detail?.course_detail?.id === courseId)
                  .map((s) => s.topic_detail?.id)
              ).size;
              return (
                <div key={courseId} className="card bg-base-200">
                  <div className="card-body p-4">
                    <div className="flex flex-col sm:flex-row justify-between gap-4">
                      <div>
                        <h3 className="font-medium text-lg">{course.title}</h3>
                        <div className="badge badge-outline mt-1">{course.code}</div>
                        <p className="text-sm opacity-70 mt-2">{course.description}</p>
                        <div className="mt-2 text-sm">
                          <span className="opacity-70">Level: </span>
                          <span className="font-medium">{course.level}</span>
                          <span className="mx-2">•</span>
                          <span className="opacity-70">Topics: </span>
                          <span className="font-medium">{courseTopics}</span>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <Link to={`/topics/${courseId}`} className="btn btn-outline btn-sm">
                          View Course
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      )}
    </div>
  </div>
);

export default CoursesTab;